export const handleError = (res) => {
  if (res.status == 200 || res.status == 201 || res.status == 202 || res.status == 204 || res.status == 403) {
    return res;
  } else if (res.status == 400) {
    throw new Error("Ссылка не действительна, введите e-mail повторно");
  } else if (res.status == 401) {
    throw new Error("Неверный токен");
  } else {
    throw new Error("Неизвестная ошибка");
  }
};
